module.exports = __webpack_public_path__ + "static/media/honest-market.71f208f6.svg";